import { useTheme } from 'styled-components';
import { Card } from '@packages/utils';
import { Paragraph, Title } from 'components/Base/Typography';
import { Col } from 'components/Base/Grid';
import { TErrorPageViewProps } from './ErrorPageView.types';
import { SErrorPageWrapper, SImage } from './ErrorPageView.styles';

const ErrorPageView = ({
  imgSrc,
  alt,
  title,
  description,
  onReset,
}: TErrorPageViewProps) => {
  const theme = useTheme();
  return (
    <Card className="m-4">
      <SErrorPageWrapper justify="center" className="py-10">
        <Col>
          <SImage src={imgSrc} alt={alt} />
          <Title level={2} color={theme?.colorPrimaryDefault || '#0077a0'}>
            {title}
          </Title>
          <Paragraph
            style={{
              whiteSpace: 'pre-wrap',
              textAlign: 'left',
              maxWidth: 600,
              margin: '0 auto',
            }}
          >
            {description}
          </Paragraph>
          {onReset && (
            <button
              type="button"
              onClick={onReset}
              style={{
                marginTop: 16,
                padding: '8px 24px',
                cursor: 'pointer',
                backgroundColor: theme?.colorPrimaryDefault || '#0077a0',
                color: 'white',
                border: 'none',
                borderRadius: 4,
                fontSize: 14,
              }}
            >
              Try again
            </button>
          )}
        </Col>
      </SErrorPageWrapper>
    </Card>
  );
};

export default ErrorPageView;
